module.exports = __webpack_public_path__ + "static/media/3_click_view.430dda8c.png";